var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoldenStarFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.37799 1.84996C8.5296 1.38335 9.18973 1.38335 9.34134 1.84996L10.8495 6.49176C10.9174 6.70043 11.1118 6.84171 11.3312 6.84171H16.2119C16.7025 6.84171 16.9065 7.46953 16.5096 7.75791L12.561 10.6267C12.3835 10.7557 12.3093 10.9843 12.3771 11.1929L13.8853 15.8347C14.0369 16.3013 13.5028 16.6894 13.1059 16.401L9.15736 13.5322C8.97985 13.4032 8.73948 13.4032 8.56197 13.5322L4.61343 16.401C4.2165 16.6894 3.68245 16.3013 3.83406 15.8347L5.34227 11.1929C5.41008 10.9843 5.3358 10.7557 5.15829 10.6267L1.20974 7.75791C0.812821 7.46953 1.01681 6.84171 1.50743 6.84171H6.38811C6.60752 6.84171 6.80198 6.70043 6.86978 6.49176L8.37799 1.84996Z",
    fill: "#EE7233",
    stroke: "#EE7233",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldenStarFilled);
export default __webpack_public_path__ + "static/media/golden_star_filled.01c50bf32e29f154089ade82bc8f9a0c.svg";
export { ForwardRef as ReactComponent };